import { Component, Input } from '@angular/core'

@Component({
    selector: 'mg-configurator-select-option',
    template: '',
})
export class ConfiguratorSelectOptionComponent {
    @Input()
    value

    @Input()
    label
}
